<app-service-settings-common
    [settingsKey]="SERVICE_SETTINGS_NURSE_RECORD_TYPE_KEY"
    [title]="'service.settings.nurse-record.header'"
></app-service-settings-common>
